import React from 'react'
import TabPicture from '../TabPicture'
import TabVideo from '../TabVideo'

const TabCard = ({ type = 'picture', image, video, text, description, link, config, ...props }) => {
  if (type === 'video') {
    return (
      <TabVideo
        video={video}
        text={text}
        description={description}
        link={link}
        config={config}
        {...props}
      />
    )
  }

  return (
    <TabPicture
      image={image}
      text={text}
      description={description}
      link={link}
      config={config}
      {...props}
    />
  )
}

export default TabCard
